module.exports = __webpack_public_path__ + "img/sebby-profilePix.a45ed011.jpg";